module.exports = __webpack_public_path__ + "static/media/elmo.93ed6791.gif";